module.exports = __webpack_public_path__ + "media/images/allow_right-86ddd0c0ba839ad22222fdd6cfb06518.svg";